import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Modal as ANTDModal } from "antd";
import * as Icon from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { Nav, NavLink, NavItem, Collapse } from "reactstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import HorizontalSidebarData from "../sidebardata/HorizontalSidebarData";
import NavItemContainer from "./NavItemContainer";
import NavSubMenu from "./NavSubMenu";
import {
  getProfileDetails,
  userDeleteInitial,
  userDeleteFailed,
} from "../../../slices/retailer/UserAppSlice/UserDetailsSlice";
import { fetchData } from "../../../slices/authSlice/dataSlice";
import logo from "../../../assets/images/logos/logo-2.png";
import miniLogo from "../../../assets/images/logos/logo-mob.png"
import favicon from "../../../assets/images/logos/favicon.png";
import { logout } from "../../../slices/authSlice/userSilce";
import { ToggleMobileSidebar } from "../../../store/customizer/CustomizerSlice";


const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const getActive = document.getElementsByClassName("activeLink");
  const currentURL = location.pathname.split("/").slice(0, -1).join("/");
  const { user: currentUser } = useSelector((state) => state.user);
  const { token: Usertoken } = useSelector((state) => state.user);
  const { items: userDetails } = useSelector((state) => state.data);
  const userDeleteResponse = useSelector(
    (state) => state.userdetails.userDeleteSucces
  );
  const [, setProData] = useState([]);
  const activeBg = useSelector((state) => state.customizer.sidebarBg);
  const isFixed = useSelector((state) => state.customizer.isSidebarFixed);
  const isMiniSidebar = useSelector((state) => state.customizer.isMiniSidebar);
  const [sr_name, setsr_name] = useState("");
  const [sr_number, setsr_number] = useState("");

  const [collapseState, setCollapseState] = useState({
    reports: false,
    settings: false,
  });

  const toggleCollapse = (menu) => {
    setCollapseState((prev) => ({
      reports: menu === "reports" ? !prev.reports : false,
      settings: menu === "settings" ? !prev.settings : false,
    }));
  };

  const handleNavLinkClick = () => {
    setCollapseState({ reports: false, settings: false });
    dispatch(ToggleMobileSidebar());
  };

  useEffect(() => {
    dispatch(fetchData({ Usertoken, currentUser }));
  }, [dispatch]);

  const setting = useMemo(() => {
    const list = [
      {
        title: "Change Password",
        href: "/Agent/ChangePassword",
        icon: <i class="fa-solid fa-angle-right"></i>,
        id: 12.1,
        collapisble: false,
      },
      {
        title: "Set TPIN",
        href: "/Agent/SetTPIN",
        icon: <i class="fa-solid fa-angle-right"></i>,
        id: 12.2,
        collapisble: false,
      },
      {
        title: "Raise Complaint",
        href: "/Agent/ComplaintListAgent",
        icon: <i class="fa-solid fa-angle-right"></i>,
        id: 12.2,
        collapisble: false,
      },
    ];
    if (!_.isEmpty(userDetails) && userDetails.api_user) {
      // list.push(
      //   {
      //     title: "Developer Documents",
      //     href: "/Agent/developerDocuments",
      //     // icon: <Icon.ChevronRight />,
      //     icon: <i class="fa-solid fa-angle-right"></i>,
      //     id: 12.3,
      //     collapisble: false,
      //   })
    }
    return list
  }, [userDetails])

  const agentReports = [
    {
      title: "Ledger",
      href: "/Reports/LedgerReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 1,
      collapisble: false,
    },
    {
      title: "Transaction",
      href: "/Reports/TransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 2,
      collapisble: false,
    },
    {
      title: "Bene-Verify",
      href: "/Reports/BeneVerifyReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 3,
      collapisble: false,
    },
    {
      title: "AEPS Transaction",
      href: "/Reports/AEPSTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 4,
      collapisble: false,
    },
    {
      title: "PG Transaction",
      href: "/Reports/PGTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 5,
      collapisble: false,
    },
    {
      title: "TDS Transaction",
      href: "/Reports/TDSTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 6,
      collapisble: false,
    },
    {
      title: "GST Transaction",
      href: "/Reports/GSTTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 7,
      collapisble: false,
    },
    {
      title: "Bill Payement",
      href: "/Reports/AgentBillPayementReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 8,
      collapisble: false,
    },
    {
      title: "Cashout",
      href: "/Reports/CashoutReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 9,
      collapisble: false,
    },
  ];

  const distributorLedger = [
    {
      title: "Ledger",
      href: "/Reports/LedgerReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 1,
      collapisble: false,
    },
    {
      title: "Transaction",
      href: "/Reports/TransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 2,
      collapisble: false,
    },
    {
      title: "Bene-Verify",
      href: "/Reports/BeneVerifyReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 3,
      collapisble: false,
    },
    {
      title: "AEPS Transaction",
      href: "/Reports/AEPSTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 4,
      collapisble: false,
    },
    {
      title: "PG Transaction",
      href: "/Reports/PGTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 5,
      collapisble: false,
    },
    {
      title: "TDS Transaction",
      href: "/Reports/TDSTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 6,
      collapisble: false,
    },
    {
      title: "GST Transaction",
      href: "/Reports/GSTTransactionReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 7,
      collapisble: false,
    },
    {
      title: "Bill Payement",
      href: "/Reports/AgentBillPayementReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 8,
      collapisble: false,
    },
    {
      title: "Cashout",
      href: "/Reports/CashoutReport",
      icon: <i class="fa-solid fa-angle-right"></i>,
      id: 9,
      collapisble: false,
    },
  ];

  useEffect(() => {
    if (userDeleteResponse === true) {
      dispatch(getProfileDetails({ currentUser, Usertoken }))
        .unwrap()
        .then((res) => {
          if (res.status === true) {
            setProData(res.data[0].ProfilePic);
            dispatch(userDeleteInitial());
          } else {
            dispatch(userDeleteFailed(res));
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [userDeleteResponse]);

  useEffect(() => {
    dispatch(getProfileDetails({ currentUser, Usertoken }))
      .unwrap()
      .then((res) => {
        if (res.status.type === "success") {
          dispatch(userDeleteInitial());
          setProData(res.data[0].ProfilePic);
          setsr_name(res.data[0].senior_FirstName);
          setsr_number(res.data[0].senior_Mobile);
        } else {
          dispatch(userDeleteFailed(res));
        }
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    if (userDeleteResponse === true) {
      dispatch(getProfileDetails({ currentUser, Usertoken }))
        .unwrap()
        .then((res) => {
          if (res.status === "true") {
            dispatch(userDeleteInitial());
            setProData(res.data);
          } else {
            dispatch(userDeleteFailed(res));
            setLoading(false);
          }
        })
        .catch(() => { });
    }
  }, [userDeleteResponse]);

  const handleLogoutClick = () => {
    ANTDModal.confirm({
      title: "Logout",
      content: "Are you sure to Logout?",
      onCancel() { },
      onOk() {
        window.addEventListener("beforeunload", () => {
          dispatch(logout());
        });
        navigate("/", { replace: true });
        window.location.reload();
      },
    });
  };
  const getUrlPath = location.pathname;

  useEffect(() => {
    if (currentUser.password_Reset) {
      const checkUrl = !_.includes(
        [
          [
            "/Admin/ChangesPasswordAd",
            "/Business/ChangePasswordBD",
            "/MasterDistributor/ChangePasswordMd",
            "/SuperDistributor/ChangePasswordSP",
            "/Distributor/ChangePasswordDistributer",
            "/Agent/ChangePassword",
            "/Employee/ChangePasswordEMP",
          ],
        ],
        getUrlPath
      );
      if (checkUrl) {
        if (currentUser.role == "1") {
          navigate("/Admin/ChangesPasswordAd");
        } else if (currentUser.role == "2") {
          navigate("/Business/ChangePasswordBD");
        } else if (currentUser.role == "3") {
          navigate("/MasterDistributor/ChangePasswordMd");
        } else if (currentUser.role == "4") {
          navigate("/SuperDistributor/ChangePasswordSP");
        } else if (currentUser.role == "5") {
          navigate("/Distributor/ChangePasswordDistributer");
        } else if (currentUser.role == "6") {
          navigate("/Agent/ChangePassword");
        } else if (currentUser.role == "7") {
          navigate("/Employee/ChangePasswordEMP");
        }
      }
    }
  }, [getUrlPath, currentUser]);

  return (
    <div className={`sidebarBox   ${isFixed ? "fixedSidebar" : ""}`}>
      {currentUser.role !== "1" ? (
        <div className={isMiniSidebar ? "minilogo-holder" : "logo-Holder"}>
          <img src={isMiniSidebar ? miniLogo : logo} alt="logo" />
        </div>
      ) : null}

      <Nav vertical className={activeBg === "white" ? "" : "lightText"}>
        {!currentUser.password_Reset ? (
          currentUser.role === "6" && currentUser.kycStatus ? (
            <Fragment>
              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Dashboards/RetailerDashboard">
                  <i class="fa-solid fa-house"></i>
                  <span>Dashboard</span>
                </NavLink>
              </NavItem>
              {/* Developer documnent */}
              {
                !_.isEmpty(userDetails) && userDetails.api_user && (
                  <NavItem onClick={handleNavLinkClick}>
                    <NavLink tag={Link} to="/Agent/developerDocuments">
                      <i className="fa-solid fa-file"></i>
                      <span>Developer Documents</span>
                    </NavLink>
                  </NavItem>
                )
              }

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/SelfBank/RetailorBankList">
                  <i class="fa-solid fa-building-columns"></i>
                  <span>Self Bank</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Agent/BalanceRequestHistory">
                  <i class="fa-solid fa-credit-card"></i>
                  <span>Balance Request</span>
                </NavLink>
              </NavItem>

              <NavItem className={collapseState.reports ? "activeParent" : ""}>
                <NavLink onClick={() => toggleCollapse("reports")}>
                  <i class="fa-solid fa-clipboard-list"></i>
                  <div className="dropdown-link">
                    <span>Reports</span>
                    <i
                      className={`bi fs-8 ${collapseState.reports
                          ? "bi-chevron-up"
                          : "bi-chevron-down"
                        }`}
                    />
                  </div>
                </NavLink>
                <Collapse
                  isOpen={collapseState.reports}
                  navbar
                  tag="ul"
                  className="subMenu"
                >
                  {agentReports.map((item) => (
                    <NavItem
                      key={item.title}
                      className={`hide-mini ${location.pathname === item.href ? "activeLink" : ""
                        }`}
                    >
                      <NavLink
                        tag={Link}
                        to={item.href}
                        onClick={handleNavLinkClick}
                      >
                        <span className="sidebarIcon">{item.icon}</span>
                        <span className="hide-mini">{item.title}</span>
                      </NavLink>
                    </NavItem>
                  ))}
                </Collapse>
              </NavItem>

              <NavItem className={collapseState.settings ? "activeParent" : ""}>
                <NavLink onClick={() => toggleCollapse("settings")}>
                  <i class="fa-solid fa-gear"></i>
                  <div className="dropdown-link">
                    <span>Setting</span>
                    <i
                      className={`bi fs-8 ${collapseState.reports
                          ? "bi-chevron-up"
                          : "bi-chevron-down"
                        }`}
                    />
                  </div>
                </NavLink>

                <Collapse
                  isOpen={collapseState.settings}
                  navbar
                  tag="ul"
                  className="subMenu"
                >
                  {setting.map((item) => (
                    <NavItem
                      key={item.title}
                      className={`hide-mini ${location.pathname === item.href ? "activeLink" : ""
                        }`}
                    >
                      <NavLink
                        tag={Link}
                        to={item.href}
                        onClick={handleNavLinkClick}
                      >
                        <span className="sidebarIcon">{item.icon}</span>
                        <span className="hide-mini">{item.title}</span>
                      </NavLink>
                    </NavItem>
                  ))}
                </Collapse>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/dashboards/PrivacyPolicy">
                  <i class="fa-solid fa-shield-halved"></i>{" "}
                  <span>Privacy Policy</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/dashboards/TermsAndCondition">
                  <i class="fa-solid fa-shield-halved"></i>{" "}
                  <span>Terms & Condition</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink onClick={handleLogoutClick}>
                  <i class="fa-solid fa-lock"></i> <span>Logout</span>
                </NavLink>
              </NavItem>

              <NavItem className="d-none">
                <NavLink className="gap-1">
                  <span className="hide-mini w-100">
                    <div className="">
                      <div className="fs-6 text-white position-absolute">
                        Lets
                      </div>
                      <div
                        className=" pt-2 text-white"
                        style={{ fontSize: "2.5em" }}
                      >
                        {" "}
                        <span className="fw-bold" style={{ color: "#fe6a49" }}>
                          C
                        </span>
                        onnect
                      </div>
                    </div>
                  </span>
                </NavLink>
              </NavItem>

              <NavItem className="d-none">
                <NavLink className="gap-1 py-0">
                  <div class="card text-black w-100 d-flex justify-content-center flex-column">
                    <div class="text-center">
                      <img
                        src={favicon}
                        style={{ width: "4em" }}
                        alt="payfazz"
                      />
                    </div>
                    <div
                      class="text-center fw-bold"
                      style={{ color: "#145089" }}
                    >
                      {" "}
                      Pay Fazz
                    </div>
                    <div
                      class="text-center fw-bold"
                      style={{ color: "#145089" }}
                    >
                      Name : {sr_name} <br />
                      Mobile : {sr_number}
                    </div>
                  </div>
                </NavLink>
              </NavItem>
            </Fragment>
          ) : currentUser.role === "5" && currentUser.kycStatus ? (
            <Fragment>
              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Dashboards/DistributorDashboard">
                  <i class="fa-solid fa-house"></i>
                  <span>Dashboard</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Distributor/ViewRetailerDistributor">
                  <i class="fa-solid fa-user"></i>
                  <span>Add Agent</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/Distributor/ManageCreditDebitDistributor"
                >
                  <i class="fa-solid fa-sliders"></i>
                  <span>Manage Credit/Debit</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Distributor/CreditDetailsDistributor">
                  <i class="fa-solid fa-credit-card"></i>
                  <span>Credit Details</span>
                </NavLink>
              </NavItem>

              <NavItem
                className={
                  collapseState.reports ? "activeParent d-none" : "d-none"
                }
              >
                <NavLink onClick={() => toggleCollapse("reports")}>
                  <i class="fa-solid fa-clipboard-list"></i>
                  <div className="dropdown-link">
                    <span>Reports</span>
                    <i
                      className={`bi fs-8 ${collapseState.reports
                          ? "bi-chevron-up"
                          : "bi-chevron-down"
                        }`}
                    />
                  </div>
                </NavLink>
                <Collapse
                  isOpen={collapseState.reports}
                  navbar
                  tag="ul"
                  className="subMenu"
                >
                  {distributorLedger.map((item) => (
                    <NavItem
                      key={item.title}
                      className={`hide-mini ${location.pathname === item.href ? "activeLink" : ""
                        }`}
                    >
                      <NavLink
                        tag={Link}
                        to={item.href}
                        onClick={handleNavLinkClick}
                      >
                        <span>{item.icon}</span>
                        <span>{item.title}</span>
                      </NavLink>
                    </NavItem>
                  ))}
                </Collapse>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Reports/AllReports">
                  <i class="fa-solid fa-table-list"></i>
                  <span>Reports</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/dashboards/CommisionReportDistributor">
                  <i class="fa-solid fa-money-bill-1"></i>
                  <span>Commission Report</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Distributor/ChangePasswordDistributer">
                  <i class="fa-solid fa-key"></i>
                  <span>Change Password</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Distributor/DistributorBankList">
                  <i class="fa-solid fa-building-columns"></i>
                  <span>Self Bank Master</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/Distributor/BalanceRequestHistoryDistributor"
                >
                  <i class="fa-solid fa-coins"></i>
                  <span>Balance Request</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick} className="gap-1 d-none">
                <NavLink tag={Link} to="#">
                  <i class="fa-solid fa-building-columns"></i>
                  <span>Agent Trans Details</span>
                </NavLink>
              </NavItem>
            </Fragment>
          ) : currentUser.role === "4" && currentUser.kycStatus ? (
            <Fragment>
              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/Dashboards/SuperDistributorDashboard">
                  <i class="fa-solid fa-house"></i>
                  <span>Dashboard</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/dashboards/SuperViewRetailerDistributor"
                >
                  <i class="fa-solid fa-user"></i>
                  <span>Add Distributor</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/SuperDistributor/AllPlans">
                  <i class="fa-brands fa-get-pocket"></i>
                  <span>Add Plan</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/dashboards/SuperManageCreditDebitDistributor"
                >
                  <i class="fa-solid fa-sliders"></i>
                  <span>Manage Credit/Debit</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/dashboards/SuperCreditDetailsDistributor"
                >
                  <i class="fa-solid fa-credit-card"></i>
                  <span>Credit Details</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/SuperDistributor/AllReports">
                  <i class="fa-solid fa-table-list"></i>
                  <span>Reports</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/SuperDistributor/CommisionSuperReportDistributor"
                >
                  <i class="fa-solid fa-money-bill-1"></i>
                  <span>Commission Report</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink tag={Link} to="/SuperDistributor/ChangePasswordSP">
                  <i class="fa-solid fa-key"></i>
                  <span>Change Password</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/SuperDistributor/SPDistributorBankList"
                >
                  <i class="fa-solid fa-building-columns"></i>
                  <span>Self Bank Master</span>
                </NavLink>
              </NavItem>

              <NavItem onClick={handleNavLinkClick}>
                <NavLink
                  tag={Link}
                  to="/SuperDistributor/BalanceRequestHistorySuper"
                >
                  <i class="fa-solid fa-coins"></i>
                  <span>Balance Request</span>
                </NavLink>
              </NavItem>
            </Fragment>
          ) : currentUser.role === "1" ? (
            <Fragment>
              {HorizontalSidebarData.map((navi) => {
                if (navi.caption) {
                  return (
                    <div
                      className="navCaption text-uppercase mt-4"
                      key={navi.caption}
                    >
                      {navi.caption}
                    </div>
                  );
                }
                if (navi.children) {
                  return (
                    <NavSubMenu
                      key={navi.id}
                      icon={navi.icon}
                      title={navi.title}
                      items={navi.children}
                      suffix={navi.suffix}
                      suffixColor={navi.suffixColor}
                      // toggle={() => toggle(navi.id)}
                      // collapsed={collapsed === navi.id}
                      isUrl={currentURL === navi.href}
                    />
                  );
                }
                return (
                  <NavItemContainer
                    key={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={
                      location.pathname === navi.href ? "activeLink" : ""
                    }
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              })}
            </Fragment>
          ) : (
            <h3
              className="text-warning fw-bold"
              style={{ marginLeft: "1.7rem" }}
            >
              {" "}
              User KYC is Pending
            </h3>
          )
        ) : (
          <h5
            className="text-warning fw-bold mt-5"
            style={{ marginLeft: "1.7rem" }}
          >
            User Change Password Pending
          </h5>
        )}
      </Nav>
    </div>
  );
};

export default Sidebar;
